import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
    const history = useNavigate();
    //state data
    const [isApps, setIsApps] = useState<boolean>(true); // Always expanded by default
    const [isCRM, setIsCRM] = useState<boolean>(true); // Always expanded by default
    const [isClientes, setIsClientes] = useState<boolean>(true); // Always expanded by default
    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const [iscurrentState, setIscurrentState] = useState('Apps');

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul: any = document.getElementById("two-column-menu");
            const iconItems: any = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                var id = item.getAttribute("sub-items");
                const getID = document.getElementById(id) as HTMLElement;
                if (getID)
                    getID.classList.remove("show");
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
        if (iscurrentState !== 'Apps') {
            setIsApps(false);
        }
        if (iscurrentState !== 'Admin') {
            setIsAdmin(false);
        }
    }, [
        history,
        iscurrentState,
        isApps,
        isAdmin,
    ]);

    const menuItems: any = [
        {
            label: "Menu",
            isHeader: true,
        },
        {
            id: "apps",
            label: "Aplicativos",
            icon: "ri-apps-2-line",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setIsApps(!isApps);
                setIscurrentState('Apps');
                updateIconSidebar(e);
            },
            stateVariables: isApps,
            subItems: [
                {
                    id: "chat",
                    label: "Mensagens",
                    link: "/apps-chat",
                    parentId: "apps",
                },
                {
                    id: "appscrm",
                    label: "CRM",
                    link: "/#",
                    isChildItem: true,
                    click: function (e: any) {
                        e.preventDefault();
                        setIsCRM(!isCRM);
                    },
                    parentId: "apps",
                    stateVariables: isCRM,
                    childItems: [
                        {
                            id: 2,
                            label: "Clientes",
                            link: "/#",
                            isChildItem: true,
                            click: function (e: any) {
                                e.preventDefault();
                                setIsClientes(!isClientes);
                            },
                            stateVariables: isClientes,
                            childItems: [
                                { id: 3, label: "Acompanhamento", link: "/apps-crm-clientes-acompanhamento" },
                                { id: 4, label: "Pessoa Jurídica", link: "/apps-crm-companies" },
                                { id: 5, label: "Pessoa Física", link: "/apps-crm-individuals" },
                            ]
                        },
                    ]
                },
                {
                    id: "filemanager",
                    label: "Gerenciador de Arquivos",
                    link: "/apps-file-manager",
                    parentId: "apps",
                },
            ],
        },
        {
            label: "Administração",
            isHeader: true,
        },
        {
            id: "admin",
            label: "Administração",
            icon: "ri-settings-3-line",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setIsAdmin(!isAdmin);
                setIscurrentState('Admin');
                updateIconSidebar(e);
            },
            stateVariables: isAdmin,
            subItems: [
                {
                    id: "checklist-config",
                    label: "Configuração Check List",
                    link: "/admin-checklist-config",
                    parentId: "admin",
                },
            ],
        },
    ];
    return menuItems;
};
export default Navdata;